import React from 'react';
import ReactPaginate from 'react-paginate';

const Paginationn = ({
	pageCount,
	marginPagesDisplayed,
	pageRangeDisplayed,
	onPageChange,
	forcePage
}) => (
	<ReactPaginate
		key={forcePage}
		pageCount={pageCount}
		marginPagesDisplayed={marginPagesDisplayed}
		pageRangeDisplayed={pageRangeDisplayed}
		onPageChange={onPageChange}
		{...forcePage ? { forcePage } : {}}
		previousLabel="‹"
		nextLabel="›"
		breakLabel="..."
		containerClassName="pagination pagination-sm m-0"
		pageClassName="page-item data-table-pagination-page"
		pageLinkClassName="page-link"
		nextClassName="page-item data-table-pagination-caret"
		nextLinkClassName="page-link"
		previousClassName="page-item data-table-pagination-caret"
		previousLinkClassName="page-link"
		breakClassName="page-item"
		breakLinkClassName="page-link"
		activeClassName="active"
		activeLinkClassName="active"
		disabledClassName=""
	/>
);

export default Paginationn;
